<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'债权产品列表',goback:true},{name:'债权产品明细'}]" :title="'债权产品明细'"/>
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="产品详情" name="1"></el-tab-pane>
              <el-tab-pane label="客户申请" name="2"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" v-show="tab==='2'" ref='condition'>
                <div class="left">
                    <div class="child">
                        <span class="name">贷款进度</span>
                        <el-select v-model="sendInfoOne.rate" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 主体 -->
            <!-- 产品详情 -->
            <div class="box" v-show="tab==='1'">
              <el-card class="basic box_card" header="" shadow="never">
              <div class="basisTitle">基本信息：</div>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">银行名称：</div>
                    <div class="content">{{basicInfo.bankName}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">产品名称：</div>
                    <div class="content">{{basicInfo.debtProductName}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">贷款类型：</div>
                    <div class="content">{{basicInfo.loanType}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">最高额度：</div>
                    <div class="content">{{basicInfo.maxAmount}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">最低额度：</div>
                    <div class="content">{{basicInfo.minAmount}}</div>
                </div>
                  </el-col>
                   <el-col :span="8">
                      <div class="child">
                    <div class="name">贷款期限：</div>
                    <div class="content">{{basicInfo.loanTerm}}</div>
                </div>
                  </el-col>
                   <el-col :span="8">
                    <div class="child">
                    <div class="name">担保方式：</div>
                    <div class="content">{{basicInfo.debtProductName}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
<div class="child">
                    <div class="name">年利率：</div>
                    <div class="content">{{basicInfo.yearInterest}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
<div class="child">
                    <div class="name">标签：</div>
                    <div class="content">{{basicInfo.tagStr}}</div>
                </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
<div class="child">
                    <div class="name">产品介绍：</div>
                    <div class="content super_p" v-html="basicInfo.productIntro"></div>
                </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
<div class="childMulti">
                    <div class="name">贷款须知：</div>
                    <ul>
                        <li v-for="(item,index) in basicInfo.loanKnown" :key="index">
                          {{index+1}}.<div v-html="item.content" class="cnts"></div>
                        </li>
                    </ul>
                </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="8">
                    <div class="attachment">
                    <div class="name">附件：</div>
                    <ul class="content">
                        <li v-for="(item,index) in basicInfo.fileList" :key="index">
                            <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                        </li>
                    </ul>
                </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="" shadow="never">
                <div class="basisTitle">其它信息：</div>
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">发布账号：</div>
                    <div class="content">{{basicInfo.createUserName}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">发布时间：</div>
                    <div class="content">{{basicInfo.createTime}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">更新账号：</div>
                    <div class="content">{{basicInfo.modifyUserName}}</div>
                </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                    <div class="name">更新时间：</div>
                    <div class="content">{{basicInfo.updateTime}}</div>
                </div>
                    </el-col>
                  </el-row>
              </el-card>
            </div>
            <!-- 客户申请表格 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="rateValue"
                    show-overflow-tooltip
                    
                    label="贷款进进度">
                </el-table-column>
                <el-table-column
                    prop="amount"
                    show-overflow-tooltip
                    
                    label="放款金额（万元）">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" v-show="tab==='2'" ref='pagination'>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                :close-on-click-modal="false"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <el-card class="basic box_card" header="" shadow="never">
                          <div class="basisTitle">提交信息</div>
                          <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{detailInfoDia.applicant}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfoDia.contactPhone}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{detailInfoDia.applyCompany}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfoDia.applyRemark}}</div>
                        </div>
                        <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in detailInfoDia.fileList" :key="index">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detailInfoDia.createTime}}</div>
                        </div>
                        </el-card>
                        
                        
                        
                    </div>
                    <div class="boxChild">
                        <el-card class="basic box_card" header="" shadow="never">
                          <div class="basisTitle">贷款进度信息</div>
                              <div class="child">
                                  <div class="name">贷款进度：</div>
                                  <div class="content">{{detailInfoDia.rateValue}}</div>
                              </div>
                              <div class="child">
                                  <div class="name">放款金额：</div>
                                  <div class="content">{{detailInfoDia.amount}}</div>
                              </div>
                              <div class="child">
                                  <div class="name">说明：</div>
                                  <div class="content">{{detailInfoDia.checkExplanation}}</div>
                              </div>
                              <div class="child">
                                  <div class="name">更新时间：</div>
                                  <div class="content">{{detailInfoDia.updateTime}}</div>
                              </div>
                        </el-card>
                        
                    </div>
                </div>
            </el-dialog>
        </div>
    
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    mixins:[timeMixins],
    components:{
        breadcrumb
    },
    data(){
        return{
            bHeight: void 0,
            id:'',//详情id
            tab:'1',//选项卡
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '申请人姓名'
            }, {
                value: '4',
                label: '联系手机号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                loanId:"",//申请id
                rate:'',//进度
                userName:"",//账号
                contactPhone:'',//手机号
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
                endDate:null,//结束时间
                startDate:null,//开始时间
            },//检索提交数据
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            statusList:[],
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            detailInfoDia:{
                applicant:'',
                contactPhone:'',
                applyCompany:'',
                applyRemark:'',
                fileList:[],
                createTime:'',
                rateValue:'',
                amount:'',
                checkExplanation:'',
                updateTime:'',
            },
            basicInfo:{
                bankName:"",//银行名
                debtProductName:"",//产品名称
                loanType:"",//贷款类型
                maxAmount:"",//最高额度
                minAmount:"",//最低额度
                loanTerm:"",//贷款期限
                debtProductName:"",//产品名称
                yearInterest:"",//年利率
                loanKnown:[],//贷款须知
                fileList:[],//附件：
                createName:"",//发布账号：
                createTime:"",//发布时间：
                modifyUserName:"",//更新账号：
                updateTime:"",//更新时间：
                tagStr: void 0
            },
            totalSize:null
        }
    },
    created(){
        this.getDic()
        if(this.$route.query.id){
            this.id=this.$route.query.id;
            this.sendInfoOne.loanId = this.id
            this.getData()
        }
    },
    mounted(){
      const that = this
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
     methods:{
       open({fileName,filePath}){
          const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
       },
      onReset(){
        const param = {
          currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                loanId:this.id,//申请id
                rate:'',//进度
                userName:"",//账号
                contactPhone:'',//手机号
                applicant:'',//申请人姓名
                property:null,//排序字段
                direction:null,//排序方式
                endDate:null,//结束时间
                startDate:null,//开始时间
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,param)
        this.getSelect = void 0
        this.getValue = void 0
        this.dateS = []
        this.getData()
      },
      
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        // 切换选项啦
        changeTab:function(tab){
            const that = this
            that.tab=tab.name;
            that.getData()
            if(tab.name === '2'){
              setTimeout(() => {
                that.$nextTick(() => {
                  let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90 + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
              }, 200);
              
            }
        },
        //检索事件
        retrieval:function(){},
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        getData(){
            if(this.tab == 1){
                this.$axiosc.get('backstage/debt/financing/details/'+this.id).then(res=>{
                    if(res.code == 200){
                        this.basicInfo = res.data
                    }
                })
            }else{
                if(this.dateS&&this.dateS.length>0){
                    this.sendInfoOne.startDate=this.dateS[0];
                    this.sendInfoOne.endDate=this.dateS[1];
                }else{
                    this.sendInfoOne.startDate=null;
                    this.sendInfoOne.endDate=null;
                }
                this.sendInfoOne.id="";//申请id
                this.sendInfoOne.userName='';//账号
                this.sendInfoOne.name='';//姓名
                this.sendInfoOne.applicant='';//申请人姓名
                if(this.getSelect=='1'){ //申请id
                    this.sendInfoOne.id=this.getValue;
                }else if(this.getSelect=='2'){ //账号
                    this.sendInfoOne.userName=this.getValue;
                }else if(this.getSelect=='3'){ //申请人姓名
                    this.sendInfoOne.applicant=this.getValue;
                }else if(this.getSelect=='4'){ //联系手机号
                    this.sendInfoOne.contactPhone=this.getValue;
                }
                this.$axiosc.get('backstage/debt/financing/apply/list',{params:this.sendInfoOne}).then(res=>{
                    if(res.code == 200){
                        this.tableData = res.data.content
                        this.totalSize=res.data.totalElements;
                    }
                })
            }
        },
        //查看明细
        check:function(row){
            this.$axiosc.get('backstage/apply/details/'+row.id).then(res=>{
                this.detailInfoDia = res.data
                this.dialogInfo=true;
            })
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //获取字典
        getDic:function(){
            this.$axiosz.get('backstage/sysDict/isShow/LOAN_RATE').then((r)=>{ //审核结果
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 40px);
    overflow: hidden;
    .detailBas{
        margin-top: 20px;
    }
}
.box{
    height:calc(100% - 90px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .childMulti{
      margin-top:0 !important;
      li{
        display: flex;
        align-items: flex-start;
        .cnts{
          margin-top:2px;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
  /deep/ .el-card__body{
    padding:0 !important;
  }
  .basisTitle{
    margin-bottom: 10px;
  }
  .child,.attachment{
    margin-bottom:10px;
    .name{
      width:80px;
      text-align: right;
    }
  }
}

</style>